import { HeartIcon } from "./icons";
import { GlassCard, SectionHeader } from "./ui";

export const MinistriesSection = ({ ministries, whatsapp }) => (
  <section id="ministerios" className="public-section public-ministries-section py-10 sm:py-12">
    <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
      <SectionHeader
        k="Como servimos"
        title="O Reino em primeiro lugar"
        desc="Áreas que tornam visível a nossa fé através da comunhão, do discipulado e do serviço."
      />

      <div className="public-ministry-grid grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {ministries.map((m) => {
          const Icon = m.icon || HeartIcon;
          const moreHref = whatsapp
            ? `${whatsapp}${whatsapp.includes("?") ? "&" : "?"}text=${encodeURIComponent(
                `Paz do Senhor. Gostaria de saber mais sobre o ministério de ${m.name}.`
              )}`
            : "#contactos";
          return (
            <GlassCard key={m.id} className="p-5 hover:shadow-md transition border-white dark:border-slate-900/80 bg-white dark:bg-slate-900/65">
              <div className="flex items-center gap-3">
                <div className="h-10 w-10 rounded-2xl bg-indigo-50 dark:bg-indigo-950/40 text-indigo-700 dark:text-indigo-300 flex items-center justify-center">
                  <Icon className="w-5 h-5" />
                </div>
                <div className="text-lg font-semibold text-slate-900 dark:text-slate-100">{m.name}</div>
              </div>
              <div className="mt-3 text-[11px] font-bold uppercase tracking-[0.14em] text-indigo-600 dark:text-indigo-300">Área de serviço</div>
              <p className="text-sm text-slate-600 dark:text-slate-400 mt-1.5">{m.blurb || "Uma equipa dedicada a servir a comunidade com amor e excelência."}</p>
              <a
                href={moreHref}
                target={whatsapp ? "_blank" : undefined}
                rel={whatsapp ? "noreferrer" : undefined}
                className="mt-4 inline-block text-sm font-semibold text-indigo-700 dark:text-indigo-300 hover:text-indigo-500 dark:hover:text-indigo-300"
              >
                Saber mais →
              </a>
            </GlassCard>
          );
        })}
      </div>
    </div>
  </section>
);
